import styled, { css } from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import {
  controlSize,
  type ControlSizeKey,
} from "../../../design-system/tokens/controlSizes";
import { duration, easing } from "../../../design-system/tokens/transitions";

/**
 * Per-size segment width. The `controlSize.iconButton` token gives a square
 * (e.g. 32×32 at md), but the segmented picker is a wider-than-tall shape
 * per Figma — 36×32 at md. These values keep the picker dynamic via the
 * `size` prop without inline hardcoding in the JSX.
 */
const SEGMENT_WIDTH_PX: Record<ControlSizeKey, string> = {
  sm: "32px",
  md: "40px",
  lg: "48px",
};

export const ToggleShell = styled.div<{ $size: ControlSizeKey }>`
  display: inline-flex;
  align-items: center;
  height: ${({ $size }) => controlSize.field[$size]};
  padding: 4px;
  background-color: ${rawColors.structural.white};
  border: 1px solid ${rawColors.stroke[200]};
  border-radius: 8px;
`;

export const SegmentButton = styled.button<{
  $isActive: boolean;
  $size: ControlSizeKey;
}>`
  appearance: none;
  background: none;
  border: none;
  margin: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => SEGMENT_WIDTH_PX[$size]};
  height: ${({ $size }) => controlSize.iconButton[$size]};
  border-radius: 7px;
  color: ${rawColors.text.lowEmphasis};
  transition: background-color ${duration.fast} ${easing.smooth}, color ${duration.fast} ${easing.smooth};

  &:focus-visible {
    outline: 2px solid ${rawColors.primary[500]};
    outline-offset: 2px;
  }


  ${({ $isActive }) =>
    $isActive &&
    css`
      background-color: ${rawColors.primary[100]};
      color: ${rawColors.text.lowEmphasis};
    `}
`;
